import { LineItem } from "@made-people/grease-cart";
import { isAllCartItemsInWarehouse } from "./is-all-cart-items-in-warehouse";
import { isAnyCartItemInWarehouse } from "./is-any-cart-item-in-warehouse";

type WarehouseStockMap = Record<string, Record<string, number>>;

export function getCartDeliveryPriority(
  items: LineItem[],
  warehousePriority: { id: number; name: string }[],
  cartWarehouseStock?: WarehouseStockMap,
): { priority: number; warehouseName: string } | "mixed" {
  for (let i = 0; i < warehousePriority.length; i++) {
    const warehouse = warehousePriority[i];
    const warehouseId = String(warehouse.id);

    const anyInWarehouse = isAnyCartItemInWarehouse(
      items,
      warehouseId,
      cartWarehouseStock,
    );

    if (!anyInWarehouse) continue;

    const allInWarehouse = isAllCartItemsInWarehouse(
      items,
      warehouseId,
      cartWarehouseStock,
    );

    if (allInWarehouse) {
      return { priority: i + 1, warehouseName: warehouse.name };
    }

    return "mixed";
  }

  return "mixed";
}
